(function() { window.GUID_32ad8500_1f30_4adc_85fe_a0fe1d7ae7a5 = { getGuid: function() { return "32ad8500-1f30-4adc-85fe-a0fe1d7ae7a5"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StatGroupPicker extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.personaIds = params[1];
                this.eventId = params[2];
                this.gameTypeId = params[3];
            }
            OnBindEvents() {
                this.$Control.offon(`click.${this.ControlId}`, (e) => {
                    this.handlePickerClick(e);
                });
            }
            OnDispose() { }
            OnControlRendered() { }
            handlePickerClick(_) {
                try {
                    const url = CS.Url.CSUrl("StatGroupPickerDrawer");
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        Controls.ScriptErrorLogger.DisplayError({
                            message: "Drawer URL is not provided",
                            file: "stat-group-picker.ts",
                        });
                        throw new Error("Drawer URL is not provided");
                    }
                    const params = {
                        personaIds: this.personaIds,
                        eventId: this.eventId,
                        gameTypeId: this.gameTypeId,
                    };
                    Controls.Popup.ShowAjaxModal(url, params, ({ popup, isPopup }) => {
                        if (!isPopup) {
                            return;
                        }
                        popup.$Control.offon("click.StatGroupPickerItemClick", ".list-item", (e) => {
                            this.handleItemClick(e);
                        });
                    }, ({ popup }) => { }, true);
                }
                catch (error) {
                    console.error("Error while handling picker click", error);
                }
            }
            handleItemClick(e) {
                try {
                    const $item = $(e.currentTarget);
                    const dataValue = $item.attr("data-value");
                    const statGroupId = parseInt(dataValue);
                    if (isNaN(statGroupId)) {
                        throw new Error("StatGroupId is not a number");
                    }
                    this.Trigger(StatGroupPicker.EventNames.ItemClicked, {
                        jqueryEventObject: e,
                        data: {
                            statGroupId: statGroupId,
                        },
                    });
                }
                catch (error) {
                    console.error("Error while handling item click", error);
                }
            }
            Close() {
                try {
                    const $drawer = $(".cs-stat-group-picker-drawer");
                    if (!$drawer.length) {
                        return;
                    }
                    const popup = Controls.GetInstance(Controls.Popup, $drawer, true);
                    if (!popup) {
                        return;
                    }
                    popup.Close();
                }
                catch (error) {
                    console.error("Error while closing picker", error);
                }
            }
        }
        Controls.StatGroupPicker = StatGroupPicker;
        (function (StatGroupPicker) {
            class Events {
                static ItemClicked(param) {
                    Controls.RegisterEvent(StatGroupPicker, EventNames.ItemClicked, param);
                }
            }
            StatGroupPicker.Events = Events;
            class EventNames {
            }
            EventNames.ItemClicked = "stat-group-picker-item-clicked";
            StatGroupPicker.EventNames = EventNames;
        })(StatGroupPicker = Controls.StatGroupPicker || (Controls.StatGroupPicker = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stat-group-picker.js.map
